const IconMarkerMap = ({ fill = '#FFFFFF' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10 2C13.866 2 17 5.18858 17 9.12189C17 11.7112 14.9045 14.4482 10.8016 17.4281L10.445 17.6841L10 18L9.55495 17.6841C5.21699 14.6047 3 11.7852 3 9.12189C3 5.18858 6.13401 2 10 2ZM10 4C7.24638 4 5 6.28549 5 9.12189C5 10.7706 6.48662 12.8514 9.68512 15.297L10 15.5348L10.3149 15.297C13.5134 12.8514 15 10.7706 15 9.12189C15 6.28549 12.7536 4 10 4ZM10 7C11.1046 7 12 7.89543 12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9C8 7.89543 8.89543 7 10 7Z" fill={fill}/>
    </svg>
  )
}

export default IconMarkerMap;
